module.exports = __webpack_public_path__ + "media/images/weo-blanc-4c9349b2b041ba0eaf0442f8680ba716.svg";